
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <div className='ta author'>Von Sebastian Broschinski, Katharina Graf und Marc Brupbacher</div>
Die durchschnittliche Schlafzeit hat sich in der Schweiz in den letzten 30 Jahren um rund 40 Minuten verkürzt. Und wir schlafen nicht nur weniger, sondern auch schlechter. Ein Drittel der Schweizerinnen und Schweizer leidet unter Schlafstörungen, bei 10 bis 20 Prozent ist es chronisch. Haben wir verlernt, richtig zu schlafen? Was hilft wirklich beim Einschlafen und wie gefährlich ist Schlaflosigkeit? Und wie träumen eigentlich Blinde? Wir haben die 77 wichtigsten Fragen zum Thema Schlaf für Sie beantwortet.
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;